import { Header } from "semantic-ui-react";
import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import {
  InputFile,
  InputText,
  InputTextBox,
  InputToggle,
} from "../../../components/Inputs/Inputs";
import BackButton from "../../../components/BackButton/BackButton";
import { api } from "../../../api/api";
import objToFormdata from "../../../utils/objToFormdata";
import { useToast } from "../../../components/Toast";
import {
  country_url,
  all_first_category_url,
  product_url,
  reels_url,
  all_second_category_url,
  all_third_category_url,
  seller_url,
} from "../../../api/urls";
import { urlTofile } from "../../../utils/urlTofile";
import unknownError from "../../../utils/unknownError";
import { APIDropdown } from "../../../components/APIDropdown/APIDropdown";
import { moveUpToError } from "../../../utils/moveUpToError";
import Loading from "../../../components/Loading/Loading";
import { modules } from "../../../api/codes";
import { ApprovalText } from "../../../utils/approveLevel";

const initialState = {
  code: "",
  description: "",
  printable_name: "",
  disable: false,
  is_active: false,
  title: "",
  reels_video: "",
  product: "",
  first_category: "",
  second_category: "",
  third_category: "",
  country: "",
  seller_video: "",
  // user: 569,
};

const module = modules.Reel;

const title = "Reels";
const backUrl = "/masters/reels";
const apiUrl = reels_url;

const NewReels = ({ edit, view }) => {
  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const history = useHistory();
  const params = useParams();
  const toast = useToast();
  const [isGetting, setIsGetting] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [aprvlLoader, setAprvlLoader] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (edit || view || params.id) {
      const getData = async () => {
        try {
          const res = await api.get(apiUrl + params.id + "/", {
            headers: {
              module: module,
            },
          });
          res.data.reels_video = await urlTofile(res.data.reels_video);
          setData(res.data);
          setIsGetting(false);
        } catch (err) {
          unknownError(err);
          setIsGetting(false);
        }
      };

      getData();
    } else {
      setIsGetting(false);
    }
  }, [params.id, edit, view, refresh]);

  const set = (key, value) => {
    setData((d) => {
      const newData = { ...d };
      newData[key] = value;
      return newData;
    });
  };
  if (isGetting) return <Loading />;

  return (
    <form
      id="form-wrapper"
      onSubmit={async (e) => {
        e.preventDefault();

        try {
          setIsSaving(true);
          let response;

          if (edit && params.id) {
            // EDIT
            response = await api.patch(
              apiUrl + data.id + "/",
              objToFormdata(data),
              {
                headers: { module },
              }
            );
            console.log(response);
            toast.open("Edited data with id: " + response.data.id, "success");
          } else {
            // ADD
            response = await api.post(apiUrl, objToFormdata(data), {
              headers: { module },
            });
            toast.open("Added data with id: " + response.data.id, "success");
          }

          history.push(backUrl);
        } catch (err) {
          if (err?.response?.data) {
            toast.open(
              err.response.data?.product ||
                err.response.data.data ||
                "Something went wrong",
              "error"
            );
            setErrors(err.response.data);
            moveUpToError();
          } else {
            unknownError(err);
          }
        } finally {
          setIsSaving(false);
        }
      }}
    >
      <div id="form">
        <BackButton href={backUrl} />
        <Header>{title}</Header>
        <InputText
          label="Code"
          placeholder="Code"
          disabled={view}
          value={data.code}
          error={errors["code"]}
          required
          onChange={(v) => set("code", v)}
        />
        <InputText
          label="Printable name"
          placeholder="Printable name"
          disabled={view}
          value={data.printable_name}
          error={errors["printable_name"]}
          required
          onChange={(v) => set("printable_name", v)}
        />
        <InputTextBox
          label="Description"
          placeholder="Description"
          disabled={view}
          value={data.description}
          error={errors["description"]}
          onChange={(v) => set("description", v)}
        />

        <APIDropdown
          label="Country"
          placeholder="Country"
          required
          disabled={view}
          value={data.country}
          url={country_url}
          onChange={(v) => set("country", v)}
          error={errors["country"]}
          hasMultipleSelection
          module={module}
        />
        <InputText
          label="Title"
          placeholder="Title"
          disabled={view}
          value={data.title}
          error={errors["title"]}
          required
          onChange={(v) => set("title", v)}
        />
        <InputFile
          label="Reels video"
          placeholder="Reels video"
          disabled={view}
          value={data.reels_video}
          error={errors["reels_video"]}
          accept="video/*"
          required
          onChange={(v) => set("reels_video", v)}
        />
        <APIDropdown
          label="First category"
          placeholder="First category"
          required
          disabled={view}
          value={data.first_category}
          url={all_first_category_url}
          onChange={(v) => set("first_category", v)}
          error={errors["first_category"]}
          module={module}
          displayAs={(x) =>
            `${x.printable_name} ${x.is_global ? "(global)" : ""} ${
              x.is_b2b ? "(B2B)" : ""
            }`
          }
        />
        <APIDropdown
          label="Second category"
          placeholder="Second category"
          required
          disabled={view}
          value={data.second_category}
          url={
            data.first_category
              ? all_second_category_url +
                `?category_first=${data.first_category}`
              : all_second_category_url
          }
          onChange={(v) => set("second_category", v)}
          error={errors["second_category"]}
          module={module}
          displayAs={(x) =>
            `${x.printable_name} ${x.is_global ? "(global)" : ""} ${
              x.is_b2b ? "(B2B)" : ""
            }`
          }
        />
        <APIDropdown
          label="Third category"
          placeholder="Third category"
          required
          disabled={view}
          value={data.third_category}
          url={
            data.second_category
              ? all_third_category_url +
                `?category_second=${data.second_category}`
              : all_third_category_url
          }
          onChange={(v) => set("third_category", v)}
          error={errors["third_category"]}
          module={module}
          displayAs={(x) =>
            `${x.printable_name} ${x.is_global ? "(global)" : ""} ${
              x.is_b2b ? "(B2B)" : ""
            }`
          }
        />

        <APIDropdown
          label="Product"
          placeholder="Product"
          url={
            data.third_category
              ? product_url + `?category_third=${data.third_category}`
              : product_url
          }
          value={data.product}
          onChange={(v) => set("product", v)}
          hasPagination
          disabled={view}
          required
          error={errors["product"]}
          module={module}
        />

        <APIDropdown
          label="Seller"
          placeholder="Seller"
          url={seller_url}
          parameterForGet="firstname"
          value={data.seller_video}
          onChange={(v) => set("seller_video", v)}
          hasPagination
          disabled={view}
          required
          error={errors["seller_video"]}
          module={module}
        />
        <InputToggle
          label="Active"
          disabled={view}
          value={data.is_active}
          error={errors["is_active"]}
          onChange={(v) => set("is_active", v)}
        />

        <ApprovalText
          id={params.id}
          level={data?.approval}
          setRefresh={setRefresh}
          setAprvlLoader={setAprvlLoader}
          toast={toast}
          view={view}
          aprvlLoader={aprvlLoader}
          module={module}
          apiUrl={apiUrl}
        />
        {!view && (
          <>
            <div style={{ padding: "10px" }} />
            <div className="actions">
              <button
                className="btn-red"
                type="button"
                onClick={() => {
                  history.push(backUrl);
                }}
              >
                Cancel
              </button>
              <button
                className="btn"
                onClick={() => {
                  moveUpToError();
                }}
                disabled={isSaving}
              >
                Save
              </button>
            </div>
          </>
        )}
        <div style={{ padding: "10px" }} />
      </div>
    </form>
  );
};

export default NewReels;
